export default __webpack_public_path__ + "static/media/ask_caryn icon.d4a7d81a.svg";